import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import Rectangle from "../../../../source/js/shared/models/Geometry/Rectangle";
import { ShapeCategory } from '@/types/shapeCategories';

export default class HeartConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'height',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle: Rectangle ): Record<string, Length> {
		const shortest_side = maximum_rectangle.get_shortest_side().in_mm();
		const longest_side = maximum_rectangle.get_longest_side().in_mm();

		const formula1 = (3 / 4 * Math.sqrt( 2 ) + 1 / 2);
		const formula2 = (Math.sqrt( 2 ) / 2 + 1);

		// Calculate based on the shortest side
		const min_width = ( shortest_side / formula1 ) * formula2;

		// If the width is too large for the max width of the rectangle, we need to recalculate.
		if ( longest_side < min_width ) {
			return {
				height: new Length( ( longest_side / formula2 ) * formula1 ),
			};
		}

		return {
			height: new Length( shortest_side ),
		};
	}

	get_labels(): Record<string, string> {
		const { height } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			height,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'complex';
	}
}
